import { useState } from 'react'

import Column from '../../../components/ReusableComponents/Column/index'
import ConfirmationDialog from '../../../components/ReusableComponents/ConfirmationDialog/index'
import { ReactComponent as BlacklistIcon } from '../blacklistRed.svg'
import Box from '../Box/index'
import { ReactComponent as LinkNewTabIcon } from '../linkNewTab.svg'
import styles from './Codes.module.scss'

const Codes = ({ title, data, handleBlacklist, handleMultiBlacklist, linkGenerator }) => {
  const [open, setOpen] = useState(false)
  const [selectedCodeList, setSelectedCodeList] = useState([])

  if (!data.length) {
    return null
  }

  function handleBlacklistClick(code) {
    setOpen(false)
    handleBlacklist(code)
  }

  function handleCheckboxChange(trackableCode, checked) {
    if (checked) {
      setSelectedCodeList([...selectedCodeList, trackableCode])
    } else {
      setSelectedCodeList([...selectedCodeList.filter(c => c !== trackableCode)])
    }
  }

  return (
    <>
      {open && (
        <ConfirmationDialog
          title={title}
          onClose={() => setOpen(false)}
          theme="blacklist"
          positiveMessage={
            selectedCodeList.length > 0
              ? `Exclude ${selectedCodeList.length} items`
              : 'Close'
          }
          handleConfirm={
            selectedCodeList.length > 0
              ? () => handleMultiBlacklist(selectedCodeList)
              : () => setOpen(false)
          }
          hasDangerousAction={selectedCodeList.length > 0}
        >
          <Column isFullWidth>
            <div className={styles.dialogContainer}>
              {data.map((c, i) => (
                <Item
                  checked={selectedCodeList.includes(c.trackableCode)}
                  handleBlacklist={() => handleBlacklistClick(c.trackableCode)}
                  handleCheckboxChange={e =>
                    handleCheckboxChange(c.trackableCode, e.target.checked)
                  }
                  inDialog
                  canBlacklist={selectedCodeList.length === 0}
                  key={c.trackableCode}
                  link={linkGenerator ? linkGenerator(c.trackableCode) : null}
                  {...c}
                />
              ))}
            </div>
          </Column>
        </ConfirmationDialog>
      )}
      <Box title={title} className={styles.halfBox}>
        <div className={styles.container}>
          {data.slice(0, 5).map(c => (
            <Item
              {...c}
              key={c.trackableCode}
              link={linkGenerator ? linkGenerator(c.trackableCode) : null}
            />
          ))}
        </div>
        <button className={styles.button} onClick={() => setOpen(true)}>
          See all {data.length}
        </button>
      </Box>
    </>
  )
}

const Item = ({
  trackableCode,
  usageCount,
  exclusion,
  inDialog,
  handleBlacklist,
  handleCheckboxChange,
  checked,
  canBlacklist,
  link
}) => (
  <div className={styles.rateCodeItem}>
    <label className={styles.rateCode}>
      {inDialog && (
        <input checked={checked} onChange={handleCheckboxChange} type="checkbox" />
      )}
      {link ? (
        <a href={link} target="_blank" rel="noopener noreferrer">
          {trackableCode} <LinkNewTabIcon />
        </a>
      ) : (
        trackableCode
      )}
    </label>
    <span className={styles.rateCodeCount} title={exclusion}>
      {!exclusion && canBlacklist && inDialog && (
        <button onClick={handleBlacklist} className={styles.blacklistButton}>
          <BlacklistIcon />
        </button>
      )}
      {exclusion && <span className={styles.excluded}>Excluded</span>}
      <span className={styles.rateCodeCountInner}>{usageCount}</span>
    </span>
  </div>
)

export default Codes
